var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUltrasoundWholeAbdomen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.565,
    height: 37.073,
    viewBox: "0 0 36.565 37.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17685"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17290"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12485",
    d: "M35.024 18.629a3.25 3.25 0 0 1 1.911 2.946v.231a.723.723 0 0 0 .665.773l9.123.654h.052a.72.72 0 0 0 .719-.67v-.117c0-.289.045-.574.045-.872a13.905 13.905 0 0 0-8.131-12.637.719.719 0 0 0-.952.358l-3.791 8.373a.723.723 0 0 0 .354.959s.003 0 .005.002z",
    transform: "translate(-14.754 -3.784)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12486",
    d: "M.4 9.366a3.123 3.123 0 0 1 1.8 2.828v.222a.69.69 0 0 0 .625.742l8.575.628h.048a.683.683 0 0 0 .676-.643v-.112c0-.277.042-.551.042-.837A13.368 13.368 0 0 0 4.52.061a.67.67 0 0 0-.895.344L.063 8.443a.7.7 0 0 0 .337.921v.002z",
    transform: "rotate(122 6.849 21.283)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 145",
    d: "M35.024 18.629a3.25 3.25 0 0 1 1.911 2.946v.231a.723.723 0 0 0 .665.773l9.123.654h.052a.72.72 0 0 0 .719-.67v-.117c0-.289.045-.574.045-.872a13.905 13.905 0 0 0-8.131-12.637.719.719 0 0 0-.952.358l-3.791 8.373a.723.723 0 0 0 .354.959s.003 0 .005.002zm4.434-8.066a12.473 12.473 0 0 1 6.672 11.013v.166l-7.768-.556a4.689 4.689 0 0 0-2.111-3.522zm0 0",
    transform: "translate(-14.754 -3.784)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "M28.386 37.82a.719.719 0 0 0-1.008-.137 3.22 3.22 0 0 1-3.912 0 .724.724 0 0 0-1.013.137l-5.574 7.315a.718.718 0 0 0 .137 1.008 13.813 13.813 0 0 0 16.8 0 .719.719 0 0 0 .139-1.008zm-2.969 9.731a12.325 12.325 0 0 1-6.941-2.162l4.721-6.2a4.649 4.649 0 0 0 4.447 0l4.719 6.2a12.339 12.339 0 0 1-6.946 2.162zm0 0",
    transform: "translate(-7.135 -16.006)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 147",
    d: "M17.017 22.326a.721.721 0 0 0 .175-.527v-.233A3.246 3.246 0 0 1 19.1 18.62a.717.717 0 0 0 .358-.952L15.657 9.3a.722.722 0 0 0-.952-.358 13.906 13.906 0 0 0-8.174 12.634 5.916 5.916 0 0 0 .043.872v.117a.724.724 0 0 0 .724.67h.078l9.175-.654a.718.718 0 0 0 .466-.255zm-9.043-.585v-.166a12.468 12.468 0 0 1 6.672-11.012l3.206 7.1a4.7 4.7 0 0 0-2.113 3.522zm0 0",
    transform: "translate(-2.785 -3.784)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 148",
    d: "M26.637 29.626a3 3 0 1 0 3-3 3 3 0 0 0-3 3zm3-1.562a1.564 1.564 0 1 1-1.564 1.562 1.561 1.561 0 0 1 1.568-1.562zm0 0",
    transform: "translate(-11.359 -11.352)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 149",
    d: "M18.283 36.565A18.283 18.283 0 1 0 0 18.274a18.285 18.285 0 0 0 18.283 18.291zm0-35.131a16.842 16.842 0 1 1-16.84 16.84 16.84 16.84 0 0 1 16.84-16.84zm0 0",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12484",
    d: "M35.024 18.629a3.25 3.25 0 0 1 1.911 2.946v.231a.723.723 0 0 0 .665.773l9.123.654h.052a.72.72 0 0 0 .719-.67v-.117c0-.289.045-.574.045-.872a13.905 13.905 0 0 0-8.131-12.637.719.719 0 0 0-.952.358l-3.791 8.373a.723.723 0 0 0 .354.959s.003 0 .005.002zm4.434-8.066a12.473 12.473 0 0 1 6.672 11.013v.166l-7.768-.556a4.689 4.689 0 0 0-2.111-3.522zm0 0",
    transform: "translate(-14.754 -3.784)",
    style: {
      fill: "#6f7e8e"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltrasoundWholeAbdomen);
export default __webpack_public_path__ + "static/media/Ultrasound Whole Abdomen.ced52c307e3b51cb614635873096137a.svg";
export { ForwardRef as ReactComponent };